import { Link } from "react-router-dom";
import { CarFront, Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { WhatsAppIcon } from "@/components/icons";
import { useSettings } from "@/hooks/useSettings";
import { telHref } from "@/lib/api";

export default function Footer() {
  const s = useSettings();
  const phone = s.phone || "591 063 123";
  const email = s.email || "taxiparkgeorgia@gmail.com";
  const address = s.address || "თბილისი, პეტრე ქავთარაძის 48";
  const maps = s.maps_url || "https://share.google/OWcepd2xfwMkeLMy1";
  const whatsapp = s.whatsapp_url || "https://wa.me/995591063123";

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0A0B0E] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 text-white font-bold text-lg mb-4">
            <CarFront className="w-6 h-6 text-[#D4AF37]" />
            taxipark<span className="text-[#D4AF37]">.ge</span>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed" data-testid="footer-text">
            {s.footer_text || "ავტომობილების გაქირავება ტაქსის მძღოლებისთვის თბილისში — სრული ტექნიკური მომსახურებით, დაზღვევითა და ლიცენზიით."}
          </p>
          {s.instagram && (
            <div className="flex gap-3 mt-5" data-testid="footer-socials">
              {s.instagram && (
                <a href={s.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-9 h-9 rounded-lg bg-white/5 border border-white/15 flex items-center justify-center text-gray-400 hover:text-[#E5C378] hover:border-[#D4AF37]/40 transition-colors">
                  <Instagram className="w-4 h-4" />
                </a>
              )}
            </div>
          )}
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">ნავიგაცია</h4>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-link-catalog" to="/catalog" className="text-gray-400 hover:text-[#E5C378] transition-colors">ავტომობილების კატალოგი</Link></li>
            <li><Link data-testid="footer-link-apply" to="/apply" className="text-gray-400 hover:text-[#E5C378] transition-colors">განაცხადის შევსება</Link></li>
            <li><Link data-testid="footer-link-about" to="/about" className="text-gray-400 hover:text-[#E5C378] transition-colors">ჩვენ შესახებ</Link></li>
            <li><Link data-testid="footer-link-privacy" to="/privacy" className="text-gray-400 hover:text-[#E5C378] transition-colors">კონფიდენციალურობის პოლიტიკა</Link></li>
            <li><Link data-testid="footer-link-terms" to="/terms" className="text-gray-400 hover:text-[#E5C378] transition-colors">წესები და პირობები</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">კონტაქტი</h4>
          <ul className="space-y-3 text-sm text-gray-400">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#D4AF37]" /><a data-testid="footer-phone" href={telHref(phone)} className="hover:text-white transition-colors">{phone}</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#D4AF37]" /><a data-testid="footer-email" href={`mailto:${email}`} className="hover:text-white transition-colors">{email}</a></li>
            <li>
              <a data-testid="footer-address" href={maps} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white transition-colors group">
                <MapPin className="w-4 h-4 text-[#D4AF37] group-hover:scale-110 transition-transform" />
                <span className="underline-offset-4 decoration-white/30 group-hover:underline group-hover:decoration-[#D4AF37]/60">{address}</span>
              </a>
            </li>
            <li>
              <a data-testid="footer-whatsapp" href={whatsapp} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white transition-colors group">
                <WhatsAppIcon className="w-4 h-4 text-[#D4AF37] group-hover:scale-110 transition-transform" />
                <span className="underline-offset-4 decoration-white/30 group-hover:underline group-hover:decoration-[#D4AF37]/60">WhatsApp: {phone}</span>
              </a>
            </li>
            {s.facebook && (
              <li>
                <a data-testid="footer-facebook-page" href={s.facebook} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white transition-colors group">
                  <Facebook className="w-4 h-4 text-[#D4AF37] group-hover:scale-110 transition-transform" />
                  <span className="underline-offset-4 decoration-white/30 group-hover:underline group-hover:decoration-[#D4AF37]/60">Facebook</span>
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} taxipark.ge — ყველა უფლება დაცულია
      </div>
    </footer>
  );
}
